import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import WarehouseService from "services/warehouseService";
import Utils from "utils";
import openNotification from "utils/notification";

//Material Category
export const getAllMaterialCategory = createAsyncThunk(
  "manageWarehouse/getAllMaterialCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseService.getAllMaterialCategory(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createMaterialCategory = createAsyncThunk(
  "manageWarehouse/createMaterialCategory",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.createMaterialCategory(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateMaterialCategory = createAsyncThunk(
  "manageWarehouse/updateMaterialCategory",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.updateMaterialCategory(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteMaterialCategory = createAsyncThunk(
  "manageWarehouse/deleteMaterialCategory",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.deleteMaterialCategory(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

//Material
export const getAllMaterial = createAsyncThunk(
  "manageWarehouse/getAllMaterial",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseService.getAllMaterial(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const getMaterialDetail = createAsyncThunk(
  "manageWarehouse/getMaterialDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseService.getMaterialDetail(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createMaterial = createAsyncThunk(
  "manageWarehouse/createMaterial",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.createMaterial(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateMaterial = createAsyncThunk(
  "manageWarehouse/updateMaterial",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.updateMaterial(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteMaterial = createAsyncThunk(
  "manageWarehouse/deleteMaterial",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.deleteMaterial(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const deleteMultiMaterial = createAsyncThunk(
  "manageWarehouse/deleteMultiMaterial",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ids } = data;
      const response = await WarehouseService.deleteMultiMaterial({ ids });
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

//Material Unit
export const getAllMaterialUnit = createAsyncThunk(
  "manageWarehouse/getAllMaterialUnit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseService.getAllMaterialUnit(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const createMaterialUnit = createAsyncThunk(
  "manageWarehouse/createMaterialUnit",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.createMaterialUnit(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateMaterialUnit = createAsyncThunk(
  "manageWarehouse/updateMaterialUnit",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.updateMaterialUnit(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteMaterialUnit = createAsyncThunk(
  "manageWarehouse/deleteMaterialUnit",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.deleteMaterialUnit(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

//MATERIAL CATEGORY V2
export const getAllMaterialCategoryV2 = createAsyncThunk(
  "manageWarehouse/getAllMaterialCategoryV2",
  async (payload, { rejectWithValue }) => {
    try {
      const { partnerId } = payload;
      const response =
        await WarehouseService.getAllMaterialCategoryV2(partnerId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createMaterialCategoryV2 = createAsyncThunk(
  "manageWarehouse/createMaterialCategoryV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.createMaterialCategoryV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateMaterialCategoryV2 = createAsyncThunk(
  "manageWarehouse/updateMaterialCategoryV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.updateMaterialCategoryV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteMaterialCategoryV2 = createAsyncThunk(
  "manageWarehouse/deleteMaterialCategoryV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.deleteMaterialCategoryV2(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

//MATERIAL CATEGORY TOOL
export const getAllMaterialCategoryTool = createAsyncThunk(
  "manageWarehouse/getAllMaterialCategoryTool",
  async (payload, { rejectWithValue }) => {
    try {
      const { partnerId } = payload;
      const response =
        await WarehouseService.getAllMaterialCategoryTool(partnerId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);


//MATERIAL V2
export const getAllMaterialV2 = createAsyncThunk(
  "manageWarehouse/getAllMaterialV2",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseService.getAllMaterialV2(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const getMaterialDetailV2 = createAsyncThunk(
  "manageWarehouse/getMaterialDetailV2",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseService.getMaterialDetailV2(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createMaterialV2 = createAsyncThunk(
  "manageWarehouse/createMaterialV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.createMaterialV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateMaterialV2 = createAsyncThunk(
  "manageWarehouse/updateMaterialV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.updateMaterialV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//MATERIAL UNIT V2
export const getAllMaterialUnitV2 = createAsyncThunk(
  "manageWarehouse/getAllMaterialUnitV2",
  async (payload, { rejectWithValue }) => {
    try {
      const { partnerId } = payload;
      const response = await WarehouseService.getAllMaterialUnitV2(partnerId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const createMaterialUnitV2 = createAsyncThunk(
  "manageWarehouse/createMaterialUnitV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.createMaterialUnitV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateMaterialUnitV2 = createAsyncThunk(
  "manageWarehouse/updateMaterialUnitV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.updateMaterialUnitV2(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteMaterialUnitV2 = createAsyncThunk(
  "manageWarehouse/deleteMaterialUnitV2",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.deleteMaterialUnitV2(id);
      if (response.data.ok) {
        if (onSuccess) onSuccess(response);
        openNotification(
          "success",
          Utils.setLocale("admin.settings.popup.notification.success"),
          Utils.setLocale("admin.settings.popup.notification.title"),
        );
      } else {
        openNotification(
          "warning",
          response.data.description,
          Utils.setLocale("admin.settings.popup.notification.title"),
        );
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const getAllSupplier = createAsyncThunk(
  "manageWarehouse/getAllSupplier",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await WarehouseService.getAllSupplier(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createSupplier = createAsyncThunk(
  "manageWarehouse/createSupplier",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.createSupplier(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateSupplier = createAsyncThunk(
  "manageWarehouse/updateSupplier",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.updateSupplier(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const delSupplier = createAsyncThunk(
  "manageWarehouse/delSupplier",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.delSupplier(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const syncMaterialPartnerApi = createAsyncThunk(
  "manageWarehouse/syncMaterialPartnerApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await WarehouseService.syncMaterialPartner(payload);
      if (onSuccess) onSuccess(response);
      // openNotification(
      //   "success",
      //   Utils.setLocale("admin.settings.popup.notification.success"),
      //   Utils.setLocale("admin.settings.popup.notification.title"),
      // );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const initialState = {
  loading: false,
  syncLoading: false,
  materialCategory: [],
  materialUnit: [],
  materialList: [],
  totalListCount: 0,
  materialDetail: {},
  supplierList: [],

  materialCategoryList: [],
  materialUnitV2: [],
  materialListV2: [],
  totalListCountV2: 0,
  materialDetailV2: {},

  materialCategoryToolList: [],
};

export const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    showSyncLoading: (state) => {
      state.syncLoading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      //Material Category
      .addCase(getAllMaterialCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllMaterialCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.materialCategory = action.payload;
      })
      .addCase(getAllMaterialCategory.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createMaterialCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMaterialCategory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMaterialCategory.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateMaterialCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMaterialCategory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMaterialCategory.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteMaterialCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteMaterialCategory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteMaterialCategory.rejected, (state, action) => {
        state.loading = false;
      })

      //Material
      .addCase(getAllMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.materialList = action.payload;
        state.totalListCount = action.payload.totalCount;
      })
      .addCase(getAllMaterial.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getMaterialDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMaterialDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.materialDetail = action.payload;
      })
      .addCase(getMaterialDetail.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMaterial.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMaterial.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMaterial.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMaterial.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteMaterial.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteMaterial.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteMaterial.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteMultiMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteMultiMaterial.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteMultiMaterial.rejected, (state) => {
        state.loading = false;
      })

      //Material Unit
      .addCase(getAllMaterialUnit.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllMaterialUnit.fulfilled, (state, action) => {
        state.loading = false;
        state.materialUnit = action.payload;
      })
      .addCase(getAllMaterialUnit.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createMaterialUnit.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMaterialUnit.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMaterialUnit.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateMaterialUnit.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMaterialUnit.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMaterialUnit.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteMaterialUnit.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteMaterialUnit.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteMaterialUnit.rejected, (state, action) => {
        state.loading = false;
      })

      //SUPPLIER
      .addCase(getAllSupplier.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllSupplier.fulfilled, (state, action) => {
        state.loading = false;
        state.supplierList = action.payload;
      })
      .addCase(getAllSupplier.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createSupplier.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSupplier.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createSupplier.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateSupplier.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSupplier.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateSupplier.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(delSupplier.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(delSupplier.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(delSupplier.rejected, (state, action) => {
        state.loading = false;
      })

      //MATERIAL CATEGORY V2
      .addCase(getAllMaterialCategoryV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllMaterialCategoryV2.fulfilled, (state, action) => {
        state.loading = false;
        state.materialCategoryList = action.payload;
      })
      .addCase(getAllMaterialCategoryV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createMaterialCategoryV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMaterialCategoryV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMaterialCategoryV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateMaterialCategoryV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMaterialCategoryV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMaterialCategoryV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteMaterialCategoryV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteMaterialCategoryV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteMaterialCategoryV2.rejected, (state, action) => {
        state.loading = false;
      })

      //MATERIAL CATEGORY TOOL
      .addCase(getAllMaterialCategoryTool.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllMaterialCategoryTool.fulfilled, (state, action) => {
        state.loading = false;
        state.materialCategoryToolList = action.payload;
      })
      .addCase(getAllMaterialCategoryTool.rejected, (state, action) => {
        state.loading = false;
      })

      //MATERIAL V2
      .addCase(getAllMaterialV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllMaterialV2.fulfilled, (state, action) => {
        state.loading = false;
        state.materialListV2 = action.payload;
        state.totalListCountV2 = action.payload.totalCount;
      })
      .addCase(getAllMaterialV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getMaterialDetailV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMaterialDetailV2.fulfilled, (state, action) => {
        state.loading = false;
        state.materialDetailV2 = action.payload;
      })
      .addCase(getMaterialDetailV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createMaterialV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMaterialV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMaterialV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateMaterialV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMaterialV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMaterialV2.rejected, (state, action) => {
        state.loading = false;
      })

      //MATERIAL UNIT V2
      .addCase(getAllMaterialUnitV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllMaterialUnitV2.fulfilled, (state, action) => {
        state.loading = false;
        state.materialUnitV2 = action.payload;
      })
      .addCase(getAllMaterialUnitV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createMaterialUnitV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMaterialUnitV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMaterialUnitV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateMaterialUnitV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMaterialUnitV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMaterialUnitV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteMaterialUnitV2.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteMaterialUnitV2.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteMaterialUnitV2.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(syncMaterialPartnerApi.pending, (state) => {
        state.syncLoading = true;
      })
      .addCase(syncMaterialPartnerApi.fulfilled, (state, action) => {
        state.syncLoading = false;
      })
      .addCase(syncMaterialPartnerApi.rejected, (state, action) => {
        state.syncLoading = false;
      });
  },
});

export const { showLoading, showSyncLoading } = warehouseSlice.actions;

export default warehouseSlice.reducer;